<Panel>

  <Panel py=1>
    <Label lg>
      Encabezado del reporte
    </Label>
  </Panel>
  <Panel>
    <Panel>
      <Label nm w="8">
        Título
      </Label>
      <Input nm
        p="xs"
        w="21"
        mb="sm"
        placeholder="Título"
        bind:value={header[1].table[0].c1}
      />
    </Panel>

    <Panel>
      <Label nm w="8">
        Logo
      </Label>
      <Input nm
        p="xs"
        w="21"
        mb="sm"
        placeholder="Logo URI"
        bind:value={header[0].image}
      />
    </Panel>
    <Panel>
      <Label xs>
        Si este campo es '#logo' utiliza el logo de su empresa.
        Si usted no ha proporcionado uno o el campo queda vacío, no se utilizará una imagen.
        Si usted desea, puede proporcionar una imagen codificada como data URI.
      </Label>
    </Panel>

    <Panel>
      <Label nm w="8">
        Ancho del logo
      </Label>
      <Input nm
        p="xs"
        w="3"
        mb="sm"
        placeholder="Ancho"
        bind:value={styles.logo.width}
      />
    </Panel>

    <Panel>
      <Label nm w="8">
        Alto del logo
      </Label>
      <Input nm
        p="xs"
        w="3"
        mb="sm"
        placeholder="Alto"
        bind:value={styles.logo.height}
      />
    </Panel>
  </Panel>

  <Panel py=1>
    <Label lg>
      Cuerpo del reporte
    </Label>
  </Panel>

  {#each reducedRecordDef.sections as section}
    {#if section.type === "ParagraphBlock"}
      <table>
        <thead>
          <tr>
            <th scope="col">Visible</th>
            <th scope="col">Párrafo el reporte</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input
                type=checkbox
                bind:checked={section.visible}>
            </td>
            <td style="text-align: left;">
              <pre>
                {section.description}
              </pre>
            </td>
          </tr>
        </tbody>
      </table>
    {:else if section.type == "SectionBlock"}
      <table>
        <thead>
          <tr>
            <th scope="col">Visible</th>
            <th scope="col">Título en el reporte</th>
            <th scope="col">Ancho</th>
            <th scope="col">Sección/Campo</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input
                type=checkbox
                bind:checked={section.visible}>
            </td>
            <td>
              <Input sm p="xs"
                w="22"
                placeholder="Titulo de {section.property}"
                bind:value={section.label} />
            </td>
            <td>
              <Input sm p="xs"
                w="3"
                placeholder="Ancho del rótulo"
                bind:value={section.width}/>
            </td>
            <td>
              {#if section.formLabel}
                <Label xs p="xs">{section.formLabel}</Label>
              {/if}
            </td>
          </tr>
  
          {#each section.controls as control}
            <tr>
              <td>
                <input
                  type=checkbox
                  bind:checked={control.visible}>
              </td>
              <td>
                <Input sm p="xs"
                  w="22"
                  placeholder="Titulo de {control.property}"
                  bind:value={control.label}/>  
              </td>
              <td>
                <!-- Empty for this type of section -->
              </td>
              <td>
                {#if control.formLabel}
                  <Label xs>{control.formLabel}</Label>
                {/if}
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    {:else}
      <table>
        <thead>
          <tr>
            <th scope="col">Visible</th>
            <th scope="col">Título en el reporte</th>
            <th scope="col">Ancho</th>
            <th scope="col">Posición</th>
            <th scope="col">Sección/Campo</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input
                type=checkbox
                bind:checked={section.visible}>
            </td>
            <td>
              <Input sm p="xs"
                w="18"
                placeholder="Titulo de {section.property}"
                bind:value={section.label} />
            </td>
            <td>
              <!-- Empty for list section header -->
            </td>
            <td>
              <!-- Empty for list section header -->
            </td>
            <td>
              {#if section.formLabel}
                <Label xs p="xs">{section.formLabel}</Label>
              {/if}
            </td>
          </tr>
          {#each section.controls as control}
            <tr>
              <td>
                <input
                  type=checkbox
                  bind:checked={control.visible}>
              </td>
              <td>
                <Input sm p="xs"
                  w="18"
                  placeholder="Titulo de {control.property}"
                  bind:value={control.label}/>  
              </td>
              <td>
                <Input sm p="xs"
                  w="3"
                  placeholder="Ancho"
                  bind:value={control.width}/>
              </td>
              <td>
                <Select
                  bg="light"
                  p="xs"
                  w="6"
                  bind:value={control.align}>
                  {#each alignment as align}
                    <option value={align.align}>{align.descr}</option>
                  {/each}
                </Select>
              </td>
              <td>
                {#if control.formLabel}
                  <Label xs>{control.formLabel}</Label>
                {/if}
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    {/if}
  {/each}
  <Panel>
    <input
      type=checkbox
      bind:checked={createdByField.visible}
    >
    <Label nm p="sm" w="12">
      {createdByField.label}
    </Label>
  </Panel>

  <Panel py=1>
    <Label lg w="10">
      Pie de página
    </Label>
  </Panel>
  <Panel>
    <Panel>
      <input
        type=checkbox
        bind:checked={footer.visible}
      >
      <Input nm
        p="xs"
        w="21"
        mb="sm"
        placeholder="Texto del footer"
        bind:value={footer.def[0].table[0].c1}
      />
    </Panel>
  </Panel>

  <Panel py="lg" align="right">
    <Button
    hover
    pointer
    color="primary"
    bg="transparent"
    border="none"
    md bold
    rounded="xs"
    py="nm"
    on:click={() => {
      if(confirm('Este cambio no podrá deshacerse. ¿Desea continuar?'))
        generateTemplate()
    }}>
        <Icon
          name="valid"
          size="lg"
          color="primary"
          mr="xs"
        />
        &nbsp;GENERAR PLANTILLA !
    </Button>
  </Panel>
</Panel>

<style>
  table {
    table-layout: fixed;
    width: 100%;
    margin-bottom: 2rem;
  }

  thead th:nth-child(1) {
    width: 10%;
  }

  thead th:nth-child(2) {
    width: 40%;
  }

  thead th:nth-child(3) {
    width: 10%;
  }

  thead th:nth-child(4) {
    width: 15%;
  }

  thead th:nth-child(5) {
    width: 25%;
  }

  td {
    text-align: center;
    vertical-align: middle;
  }
</style>

<script>
  import { onMount } from 'svelte'
  import { Button, Icon, Input, Label, Panel, Select } from 'svelte-stylo'
  import { defaultStyles } from './defaults/styles.js'
  import { defaultHeaderTitles } from './defaults/header-titles.js'
  import { acceptedFieldTypes } from './defaults/accepted-field-types.js'

  export let
    recordDef = {},
    template = {},
    onDone = null
  
  let 
    STANDARD_WIDTH = 220,
    TOTAL_WIDTH = 720,
    reducedRecordDef = {
      sections: [],
      title: ''
    },
    header = [
      {
        image: '#logo',
        style: "logo"
      },
      {
        style: "encabezado",
        table: [{
          c0: "\n\n\n",
          c1: reducedRecordDef.title,
          c2: "\n"
        }],
        titles: defaultHeaderTitles
      }
    ],
    footer = {
      visible: false,
      def: [
        {
          style: "pie",
          table: [{
            c0: "\n\n\n",
            c1: reducedRecordDef.title,
            c2: "\n"
          }],
          titles: defaultHeaderTitles
        }
      ]
    },   
    styles = defaultStyles,
    alignment = [
      {align: "left", descr: "Izquierda"},
      {align: "center", descr: "Centrado"},
      {align: "right", descr: "Derecha"}
    ],
    createdByField = {
      label: "Marca de creación",
      visible: true
    }

  onMount(() => {
    // form a reduced structure based on the record definition
    reducedRecordDef = reduceRecordDef(recordDef)
    header[1].table[0].c1 = reducedRecordDef.title
    header[1].table[0].c2 = "\n#".concat(getTicket(reducedRecordDef))
    footer.def[0].table[0].c1 = reducedRecordDef.title
    
    // if there's already a template set, take data from it
    if (template.def) {
      header = template.def.header

      // check if any section exists in the template and takes its preferences
      reducedRecordDef.sections.forEach((formSection) => {
        template.def.body.sections.forEach((templateSection) => {
          if (formSection.property == templateSection.property) {
            // formSection.formLabel = formSection.label  // save the form's label
            formSection.label = templateSection.label  // change the showing label for the template's one
            formSection.visible = templateSection.visible
            formSection.width = templateSection.width

            // check if any control exists in the template and take its preferences
            formSection.controls.forEach((formControl) => {
              templateSection.controls.forEach((templateControl) => {
                if (formControl.property == templateControl.property) {
                  // formControl.formLabel = formControl.label  // same as with the section label
                  formControl.label = templateControl.label
                  formControl.visible = templateControl.visible
                  formControl.width = templateControl.width
                }
              })
            })
          }
        })
      })
      if (template.def.footer) {
        footer = template.def.footer
      }
    } 
  })
  
  function reduceRecordDef (recordDef) {
    let 
      reduced = {
        sections: [],
        title: recordDef.title
      }
    
    recordDef.data.form.sections.forEach((section) => {
      let reducedSection = {
        controls: reduceControls(section.controls),
        formLabel: section.label,
        label: section.label,
        property: section.property,
        type: section.type,
        visible: section.titled && section.label && !section.hidden &&  section.visible,
        width: STANDARD_WIDTH
      }
      if (section.type === 'ParagraphBlock') {
        reducedSection.description = section.description
      }
      reduced.sections.push(reducedSection)
    });
    
    return reduced
  }

  function reduceControls (controls) {
    let reducedControls = []

    controls.forEach((control) => {
      let reducedControl = {
        formLabel: control.label,
        label: control.label,
        property: control.property,
        visible: !control.hidden && control.label && control.visible,
        width: TOTAL_WIDTH / controls.length,
        type: control.type
      }
      if (acceptedFieldTypes.includes(control.type)) {
        reducedControls.push(reducedControl)
      }
    })

    return reducedControls
  }

  // Search for a ticket property and returns its value, or '' if none is found
  function getTicket(reducedRecordDef) {
    let 
      ticketRegEx = /ticket*/,
      ticket = ''

    if (reducedRecordDef.sections.length) {
      reducedRecordDef.sections.forEach((section) => {
        if (section.controls.length) {
          section.controls.forEach((control) => {
            if (ticketRegEx.test(control.property)){
              ticket = control.property.slice(0)
            }
          })
        }
      })
    }

    return ticket
  }
  
  function generateTemplate() {
    let 
      genTemplate = {
        template: {
          header: header,
          body: [],
        },
        styles: styles
      }
    
    // changes on numeric text fields converts numbers to strings so we need to change them back
    styles.logo.width = parseInt(styles.logo.width)
    styles.logo.height = parseInt(styles.logo.height)

    reducedRecordDef.sections.forEach((section) => {
      if (section.type === "ParagraphBlock" && section.visible) {
        let paragraph = {
          style: 'parag',
          paragraph: section.description
        }
        genTemplate.template.body.push(paragraph)
      } else if (section.visible) {
        let sectionTitle = {
          style: 'titulo2',
          paragraph: section.label,
          visible: "#".concat(section.property)
        }
        genTemplate.template.body.push(sectionTitle)
      }
      if (section.type === "SectionBlock") {
        if (section.controls.length) {
          let tableObj = {
            style: 'tabla1',
            table: [],
            titles: [{
              width: parseInt(section.width),
              align: section.align || "left",
              prompt: "",
              name: "c1"
            },
            {
              width: TOTAL_WIDTH - parseInt(section.width),
              align: "left",
              prompt: "",
              name: "c2"
            }]
          },
          photoField = {},
          signFields = []

          section.controls.forEach((control) => {
            console.log
            if (control.visible) {
              if (control.type == "SignatureField") {
                signFields.push({
                  image: "#".concat(control.property),
                  style: "firma"
                })
                if (control.label) {
                  signFields.push({
                    paragraph: control.label,
                    style: "piedefirma"
                  })
                }
              }
              if(control.type == "PhotoField") {
                photoField.photos = '#'.concat(control.property)
                photoField.style = 'parag'
              }
              if (control.type != "SignatureField" && control.type != "PhotoField") {
                tableObj.table.push({
                  c1: control.label,
                  c2: "#".concat(control.property)
                })
              }
            }
          })
          if (tableObj.table.length) {
            genTemplate.template.body.push(tableObj)
          }
          if (Object.keys(photoField).length) {
            genTemplate.template.body.push(photoField)
          }
          if(signFields.length) {
            signFields.forEach(field => {
              genTemplate.template.body.push(field)
            });
          }
        }
      }
      if (section.type === "ListBlock") {
        let tableObj = {
          style: "tabla2",
          table: "#".concat(section.property),
          titles: []
        }
        section.controls.forEach((control) => {
          if (control.visible) {
            let title = {
              width: parseInt(control.width),
              align: control.align,
              prompt: control.label,
              name: control.property,
              headersVisible: true
            }
            tableObj.titles.push(title)
          }
        })
        if (tableObj.titles.length) {
          genTemplate.template.body.push(tableObj)
        }
      }
    })
    if (createdByField.visible) {
      let createdBy = {
        style: "parag",
        paragraph: "Realizada por #creado_por el #creado_fecha"
      }
      genTemplate.template.body.push(createdBy)
    }

    if (footer.visible) {
      genTemplate.template.footer = footer.def
    }
    
    genTemplate.def = {
      header,
      body: reducedRecordDef,
      footer                // WIP
    }

    console.log("Reduced record def: ", reducedRecordDef)
    console.log("Template: ", genTemplate)
    
    onDone(genTemplate) // callback with the template to fill the form
    return genTemplate 
  }

</script>